// src/web/components/likes-readers-page.jsx

import React from 'react'
import connect from '../../connects/likes-readers-page'
import {
  List,
  ListItem,
} from 'react-toolbox/lib/list'
import {
  Tab,
  Tabs
} from 'react-toolbox/lib/tabs'
import {
  Button,
} from 'react-toolbox/lib/button'
import {
  FontIcon,
} from 'react-toolbox/lib/font_icon'
import Tooltip from 'react-toolbox/lib/tooltip'
import classnames from 'classnames'
import Loading from './loading.jsx'
import { convertEmojiHTML } from '../../helpers/emoji-helpers'
import RightSidePage from './right-side-page.jsx'
import _ from 'lodash'
import moment from 'moment'
import diaryFormsTabTheme from './themes/diary-forms-tab.css'
import likeTheme from './themes/likes-readers.css'
import uniqWith from 'lodash/uniqWith'
import maxBy from 'lodash/maxBy'
import Avatar from 'react-toolbox/lib/avatar'
import emoji from '../../native/assets/emoji'

const TooltipButton = Tooltip(Button)

function UserReactionIcon(props) {
  const {
    like,
    likeConfig,
  } = props
  return (
    <div theme={likeTheme} >
      <img className='avatarIcon'  src={like.user.icon_image.thumb_url}/>
      <img className='reactionIcon' theme={likeTheme} src={likeConfig && emoji[likeConfig[like.like_type].icon.replace('\\u','')]}/>
    </div>)
}

function LikesList(props) {
  const {
    t,
    likes,
    likeConfig,
    showUser,
  } = props

  return (
    <List>
      {_.map(likes, (like)=> 
        <ListItem key={like.like_id} theme={likeTheme} className={classnames("avatarReaction", "pointer")}
              avatar={<UserReactionIcon like={like} likeConfig={likeConfig}/>}
              onClick={() => showUser(like.user.user_id)}
              caption={like.user.name}
              legend={<TooltipButton neutral={false} ripple={false} theme={likeTheme}
                        label={t('label:時間前にリアクション', { timestamp: moment(like.created_at).fromNow(), n: likeConfig && likeConfig[like.like_type].label })} 
                        tooltip={<div>{moment(like.created_at).format('LLLL HH:mm')} </div> }/>
                      }
        />
      )}
      {(!likes || likes.length == 0) &&
        <ListItem selectable={false} ripple={false}
          legend={t('label:いいねといっている人はまだいません')} />
      }
    </List>
  )
}

function ReadersList(props) {
  const {
    t,
    readers,
    showUser,
  } = props

  return (
    <List>
      {_.map(readers, (reader)=> 
        <ListItem key={reader.reader_id} theme={likeTheme} className="pointer"
              selectable={false} ripple={false}
              avatar={reader.user.icon_image.thumb_url}
              caption={reader.user.name}
              onClick={() => showUser(reader.user.user_id)}
              legend={<TooltipButton neutral={false} ripple={false} theme={likeTheme}
                        label={t('label:時間前に開封', { timestamp: moment(reader.created_at).fromNow() })}
                        tooltip={<div>{moment(reader.created_at).format('LLLL HH:mm')} </div>} />
                      }
        />
      )}
      {(!readers || readers.length == 0) &&
        <ListItem selectable={false} ripple={false}
          legend={t('label:開封した人はまだいません')} />
      }
    </List>
  )
}

function MentionsList(props) {
  const {
    t,
    mentions,
    showUser,
  } = props

  return (
    <List>
      {_.map(mentions, (mention)=> 
        <ListItem key={mention.user_id} theme={likeTheme} className="pointer"
              selectable={false} ripple={false}
              avatar={mention.icon_image.thumb_url}
              onClick={() => showUser(mention.user_id)}
              caption={mention.name}
              legend={mention.delivered_at && 
                <div>
                  <TooltipButton neutral={false} ripple={false} theme={likeTheme}
                        label={t('label:時間前に開封', { timestamp: moment(mention.delivered_at).fromNow() })}
                        tooltip={<div>{moment(mention.delivered_at).format('LLLL HH:mm')} </div>} />
                  {mention.replied_at && <TooltipButton neutral={false} ripple={false} theme={likeTheme}
                        label={'(' + t('label:時間前に返信', { timestamp: moment(mention.replied_at).fromNow() }) + ')'}
                        tooltip={<div>{moment(mention.replied_at).format('LLLL HH:mm')} </div>} />}
                  <FontIcon value="check" style={{ fontSize: 16, color: 'green' }} />
                </div>
              }
        />
      )}
      {(!mentions || mentions.length == 0) &&
        <ListItem selectable={false} ripple={false}
          legend={t('label:読んでみてといっている人はまだいません')} />
      }
    </List>
  )
}

function CommentList(props) {
  const {
    t,
    comments,
    reply,
    showUser,
  } = props
  const users = comments && comments.map(item => item.user)
  const uniq_users = users && uniqWith(users, (user1, user2)=> user1.user_id == user2.user_id)
  return (
    <List>
      {_.map(uniq_users, (user)=> {
        const userComments = comments.filter(item => item.user.user_id == user.user_id)
        const latestComment = maxBy(userComments, comment => comment.created_at)
        return (<ListItem key={user.user_id} theme={likeTheme} className="pointer"
                selectable={false} ripple={false}
                avatar={user.icon_image.thumb_url}
                onClick={() => showUser(user.user_id)}
                caption={user.name}
                legend={<TooltipButton neutral={false} ripple={false} theme={likeTheme}
                          label={!reply ? t('label:時間前にコメント', { timestamp: moment(latestComment.created_at).fromNow() }) : t('label:時間前に返信(tab)', { timestamp: moment(latestComment.created_at).fromNow() })} 
                          tooltip={<div>{moment(latestComment.created_at).format('LLLL HH:mm')} </div> }/>
                        }
          />)
        })}
      {(!comments || comments.length == 0) &&
        <ListItem selectable={false} ripple={false}
          legend={!reply ? t('label:コメントした人はまだいません') : t('label:返信した人はまだいません')} />
      }
    </List>
  )
}
class LikesReadersPage extends React.Component {
  render() {
    const {
      t,
      ui,
      diary,
      comment,
      isFetching,
      isFetchFailed,
      updateUI,
      likeConfig,
      showUser,
    } = this.props

    var subject, subtitle
    if (comment) {
      subject = <span>{t('label:ユーザのコメント', { name: comment.user.name })}</span>
      subtitle = t('label:時間前に送信', { timestamp: moment(comment.created_at).fromNow() })
    }
    else if (diary && diary.subject) {
      subtitle = diary.user.name
      subject = <span dangerouslySetInnerHTML={{__html: convertEmojiHTML(diary.subject)}} />
    }
    else if (diary){
      subtitle = diary.user.name
      subject = <span>
          {t('format:diary_subject', {
            reported_at: diary.reported_at,
            category: t('diary:'+diary.category)
          })}
        </span>
    }

    var children
    if (diary && comment){
      children = [
        <Tab key={1} className={classnames('tab-label', 'icon-favorite')} icon='favorite' label={t('label:リアクション')}><LikesList t={t} likes={comment.likes} likeConfig={likeConfig} showUser={showUser}/></Tab>,
        <Tab key={2} className={classnames('tab-label', 'icon-priority_high')} icon='priority_high' label={t('label:読んでみて')}>
          <MentionsList t={t} mentions={comment.mentions} showUser={showUser}/>
        </Tab>
      ]
      const isParent = comment.hasOwnProperty('comments')
      isParent && children.push(<Tab key={3} className={classnames('tab-label', 'icon-comment')} icon='comment' label={t('label:返信')}><CommentList t={t} comments={comment.comments} showUser={showUser} reply/></Tab>)
    }
    else if (diary)
      children = [
        <Tab key={1} className={classnames('tab-label','icon-favorite')} icon='favorite' label={t('label:リアクション')}><LikesList t={t} likes={diary.likes} likeConfig={likeConfig} showUser={showUser}/></Tab>,
        <Tab key={2} className={classnames('tab-label', 'icon-comment')} icon='comment' label={t('label:コメント')}><CommentList t={t} comments={diary.comments} showUser={showUser}/></Tab>,
        <Tab key={3} className={classnames('tab-label', 'icon-priority_high')} icon='priority_high' label={t('label:読んでみて')}><MentionsList t={t} mentions={diary.mentions} showUser={showUser}/></Tab>,
        <Tab key={4} className={classnames('tab-label', 'icon-check')} icon='check' label={t('label:開封')}><ReadersList t={t} readers={diary.readers} showUser={showUser}/></Tab>,
      ]
    else 
      children = []

    return (
      <RightSidePage
          title={subject}
          image={comment && comment.user.icon_image.thumb_url || diary && diary.user.icon_image.thumb_url}
          subTitle={subtitle}>
        {!isFetchFailed && isFetching && <Loading />}
        {!isFetchFailed && !isFetching && diary && 
          <Tabs index={ui.index} onChange={(index)=> updateUI({ index })} theme={diaryFormsTabTheme}>
            {children}
          </Tabs>
        }
        {isFetchFailed && 
          <div style={{ marginTop: '10px', textAlign: 'center'}}>{t('label:データの取得に失敗しました')}</div>
        }
      </RightSidePage>
    )
  }
}

export const RawLikesReadersPage = LikesReadersPage
export default connect(LikesReadersPage)




// WEBPACK FOOTER //
// ./src/web/components/likes-readers-page.jsx